package one.primehealth.app

import co.touchlab.kermit.Logger

sealed interface DeepLink {

    val uri: String

    data class Paywall(val id: String) : DeepLink {
        override val uri: String
            get() = "$PAYWALL/$id"
    }

    data class SilentLogin(val token: String) : DeepLink {
        override val uri: String
            get() = "wu/$token"
    }

    data class Insight(val id: String) : DeepLink {
        override val uri: String
            get() = "$INSIGHT/$id"
    }

    data class Recipe(val id: String) : DeepLink {
        override val uri: String
            get() = "$RECIPE/$id"
    }

    data class Workout(val id: String) : DeepLink {
        override val uri: String
            get() = "$WORKOUT/$id"
    }

    data class MealPlan(val id: String) : DeepLink {
        override val uri: String
            get() = "$MEAL_PLAN/$id"
    }

    data object Insights : DeepLink {
        override val uri: String
            get() = INSIGHTS
    }

    data object DailyTasks : DeepLink {
        override val uri: String
            get() = DAILY_TASKS
    }

    data object Today : DeepLink {
        override val uri: String
            get() = TODAY
    }

    companion object {

        // https://track.pstmrk.it/3s/hltm-carni.onelink.me%2FHetu%2Fweb%3Fdeep_link_value%3Dwu%26deep_link_sub1%3D2LQRkkMrzHc2VUlcrd4E1rfvtX83/cDjU/LEu9AQ/AQ/38658a45-422e-4a12-bdbf-8aa7beda1a29/1/L3re7I-mLB

        fun parse(value: String): DeepLink? {
            Logger.d("try parse deeplink: $value")

            if (value.startsWith("http")) {
                // handled by Appsflyer, check AppAnalyticsPlatform.kt or by web in jsMain/Main.kt
                return null
            }
            val split = value.split('/')
            Logger.d("splited deeplink: $split")

            return when (split.firstOrNull()) {
                PAYWALL -> Paywall(split.last())
                INSIGHT -> Insight(split.last())
                RECIPE -> Recipe(split.last())
                WORKOUT -> Workout(split.last())
                MEAL_PLAN -> MealPlan(split.last())
                INSIGHTS -> Insights
                DAILY_TASKS -> DailyTasks
                TODAY -> Today
                "wu" -> SilentLogin(split.last())
                "token" -> SilentLogin(split.last())
                else -> null
            }
        }

        private const val PAYWALL = "paywall"
        private const val INSIGHT = "insight"
        private const val RECIPE = "recipe"
        private const val WORKOUT = "workout"
        private const val MEAL_PLAN = "mealplan"
        private const val INSIGHTS = "insights"
        private const val DAILY_TASKS = "daily-tasks"
        private const val TODAY = "today"
    }
}